import { render, staticRenderFns } from "./showIframe.vue?vue&type=template&id=b01240e8&"
import script from "./showIframe.vue?vue&type=script&lang=js&"
export * from "./showIframe.vue?vue&type=script&lang=js&"
import style0 from "./showIframe.vue?vue&type=style&index=0&id=b01240e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports